import { StyleSheet, css } from 'aphrodite'
import type React from 'react'

interface CardRowProps {
  label: string
  value: string | React.ReactNode
  vertical?: boolean
  tooltip?: string
}

const CardRow: React.FC<CardRowProps> = ({
  label,
  value,
  vertical,
  tooltip,
}) => {
  if (!value) {
    return null
  }
  return (
    <div
      className={css(styles.cardRow, vertical && styles.cardColumn)}
      title={tooltip}
    >
      <span className={css(styles.label)}>{label}</span>
      <span className={css(styles.value, vertical && styles.valueVertical)}>
        {value}
      </span>
    </div>
  )
}

const styles = StyleSheet.create({
  cardRow: {
    display: 'grid',
    gridTemplateColumns: '120px 1fr',
    gap: '24px',
    alignItems: 'center',
    cursor: 'help',
  },
  cardColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'unset',
    gap: 6,
  },
  label: {
    color: '#6B7280',
    fontSize: '13px',
    fontWeight: 600,
    textTransform: 'uppercase',
    maxWidth: '100px',
    whiteSpace: 'nowrap',
    lineHeight: '1.4',
  },
  value: {
    color: '#111827',
    fontWeight: 500,
    textAlign: 'left',
    fontSize: '14px',
    lineHeight: '1.4',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
  },
  valueVertical: {},
})

export default CardRow
